import { useToast } from "vue-toastification";

export default (socket) => {
    const toast = useToast();
    socket.on('answer', (data) => {
        console.log(data);
        
        toast(data);
    })
}